/* 100X Equine -> Zipify OCU slide cart bridge.

   WHY THIS EXISTS. OCU decides "this click was an add to cart" by matching the clicked
   element against a fixed list of STANDARD Shopify selectors:

     [name="add"], product-form buy-buttons [type="submit"], [action*="/cart/add"] [type="submit"],
     [data-pf-type="ProductATC"], add-to-cart-component button[name="add"], .quick-add__button,
     [data-add-to-cart], [data-product-variant-id], a[href*="/cart/add?id="], ...

   The old Debut theme used that standard markup, so OCU bound itself automatically and the
   slide cart worked for years. The rebuilt buy box is fully custom: its button is
   [data-gx-add-cta] inside [data-gx-buybox] and it posts to /cart/add.js itself. That matches
   NONE of OCU's selectors, so OCU never saw an add, never refreshed, and its drawer sat there
   empty and visibility:hidden. Nothing was wrong with the OCU app - it simply was never told
   where our button is.

   Zipify ships a documented API for exactly this (custom themes). We point it at our markup:
     customAddToCartButton  - what counts as an add-to-cart click
     customAddToCartForm    - the container OCU looks up from (must exist, or OCU bails early
                              with an empty FormData before ever calling the data hook)
     getCustomAddToCartData - returns FormData; OCU reads id / quantity / selling_plan from it
     customOpenCartButton   - what opens the cart (our nav cart icon)

   OCU then performs the add AND opens its drawer. Each buy box therefore skips its own
   add when OCU is present (see the .ocu-cart-drawer guard in <product>-buy-box.js), so the
   line is never added twice.

   Safe when OCU is off: if window.Zipify never appears this does nothing, and our own cart
   drawer keeps working exactly as before. */
(function () {
  function configure() {
    var Z = window.Zipify;
    if (!Z || !Z.Cart || !Z.Cart.api) return false;
    var api = Z.Cart.api;

    api.customAddToCartButton = '[data-gx-add-cta]';
    api.customAddToCartForm = '[data-gx-buybox]';
    api.customOpenCartButton = '[data-open-cart]';
    // Must be a real selector that never matches: OCU calls closest() on it unguarded.
    if (!api.excludeActionButton) api.excludeActionButton = '[data-gx-never-exclude]';

    api.getCustomAddToCartData = function () {
      var fd = new FormData();
      var sel = null;
      try {
        sel = typeof window.GX_GET_SELECTION === 'function' ? window.GX_GET_SELECTION() : null;
      } catch (e) {}
      // No selection resolved: hand back empty FormData and let OCU fall back to its own
      // variant lookup rather than adding a wrong line.
      if (!sel || !sel.variantId) return fd;
      fd.set('id', String(sel.variantId));
      fd.set('quantity', '1');
      if (sel.sellingPlanId) fd.set('selling_plan', String(sel.sellingPlanId));
      return fd;
    };
    return true;
  }

  // OCU's bundle loads async, so keep trying briefly until its api object exists.
  if (configure()) return;
  var tries = 0;
  var iv = setInterval(function () {
    if (configure() || ++tries > 80) clearInterval(iv);
  }, 100);
})();
